import { useContext } from "react";
import { MapSettingsContext } from "./MapSettingsContext";

export function useMapSettings() {
    const context = useContext(MapSettingsContext);
    if (!context) {
        throw new Error("useMapSettings must be used within a MapSettingsProvider");
    }
    return context;
}
